<template lang="html">
    <div class="main-container">
        <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
        <section class="main-content-section">
            <tl-tabs :tabs="tabs">
                <tl-tab>
                    <upload-fbp-claim></upload-fbp-claim>
                </tl-tab>
                <tl-tab>
                    <fbp-claims-directory></fbp-claims-directory>
                </tl-tab>
            </tl-tabs>
        </section>
    </div>
</template>

<script>

    import { mapState, mapGetters, mapActions } from "vuex";
    import fbpClaimsDirectory from "./fbpClaimsDirectory.vue";
    import uploadFbpClaim from "./uploadFbpClaim.vue";

    export default {
        name: "fbpClaims",
        components: {
            fbpClaimsDirectory,
            uploadFbpClaim
        },
        computed: {
            ...mapState({}),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            })
        },
        data() {
            return {
                 breadcrumbList:[
              {
                name: "Payroll",
                url: `/dashboard/${this.$route.params.entity_index}/payroll`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
              },
              {
                name: "FBP Claims",
                url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbpClaims`
              }
        ],
                tabs: [
                    {
                        header: "Upload FBP Claim"
                    },
                    {
                        header: "FBP Claims Directory"
                    }
                ]
            };
        },
        mounted() { },

        methods: {
            ...mapActions({}),

            routeToSubStep() {
                this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities` });
            },

            routeToMainStep() {
                this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/payroll` });
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>